<template>
	<el-container>
		<el-drawer title="Advance Filter" :visible.sync="drawer" size="375px">
			<el-container id="filter-content" class="grid-filter-height-container">
				<el-main>
					<dms-form ref="mainForm" :model="model" :validate-on-rule-change="false" :rules="validationRules"
						@submit="onFilterSubmit">
						<slot name="filter" />
					</dms-form>
				</el-main>
				<el-footer height="50px" class="filter-aside-footer layout-component-padding" type="flex">
					<dms-row type="flex">
						<el-col>
							<dms-button class="grid-content" label-key="Reset" icon="el-icon-close"
								data-cy="reset" :disabled="false" style="width: 100%;" @click="filterResetClick" />
						</el-col>
						<el-col>
							<dms-button class="grid-content" type="primary" :label-key="searchButtonLabelKey" icon="el-icon-check"
								data-cy="filterSubmit" :disabled="false" style="width: 100%;" @click="onFilterSubmit" />
						</el-col>
					</dms-row>
				</el-footer>
			</el-container>
		</el-drawer>
		<el-container class="full-window-height-container">
			<el-container class="window-body">
				<el-header height="40px" class="table-buttons layout-component-padding"
					:class="{ 'half-width': halfWidth }">
					<dms-col :md="12" :sm="12" :xs="11" class="filter-display">
						<dms-button v-if="!isFilterSlotEmpty" :disabled="false" icon="icon-filter"
							class="btn-toggle-filter btn-toggle-filter--content pull-left" type="default"
							@click="toggleFilter" />
						<el-input v-if="!isFilterSlotEmpty" v-model="tableFilterQuery"
							prefix-icon="el-icon-search" :placeholder="quickSearchPlaceholder"
							class="input-auto-width input-with-select full-grid-filter-input-size" @input="debouncedFastSearch" />
					</dms-col>
					<!-- <dms-info-button v-if="!isFilterSlotEmpty && showFilter" :text="quickSearchHint" title-key="cmdInfo" /> -->

					<template v-if="(componentName)=='includeArrow'">
						<i v-if="showArrowforList" class="icon-arrow-left left-arrow-layout" @click="scrollNavbarLeft()" />
						<span ref="title" :class="(showArrowforList) ? 'button-box_for-list' :'button-box_for-list span-align'">
							<dms-button v-if="canCreate && useCreate" :disabled="false" data-cy="listVytvor" type="primary"
								label-key="cmdVytvor" @click="createClick" />
							<dms-button v-if="showReportRequestButton" :disabled="false"
								label-key="ReportRequestStatus" icon="el-icon-d-arrow-right"
								@click="navigateToReportRequests" />
							<dms-button v-if="canExport" :disabled="false" label-key="Export"
								data-cy="export-button" @click="exportClick" />

							<slot name="header" />
						</span>
						<i v-if="showArrowforList" class="icon-arrow-right right-arrow-layout" @click="scrollNavbarRight()" />
					</template>

					<template v-else>
						<div>
							<dms-button v-if="canCreate && useCreate" :disabled="false" data-cy="listVytvor" type="primary"
								label-key="cmdVytvor" @click="createClick" />
							<dms-button v-if="canExport" :disabled="false" label-key="Export"
								data-cy="export-button" @click="exportClick" />
							<dms-button v-if="showReportRequestButton" :disabled="false"
								label-key="ReportRequestStatus" icon="el-icon-d-arrow-right"
								@click="navigateToReportRequests" />
						</div>
						<slot name="header" />

					</template>
				</el-header>
				<el-main :class="[{ 'half-width': halfWidth }, mainClass]">
					<slot name="content" />
					<dms-form ref="mainForm">
						<el-col>
							<slot name="customerSearch" />
						</el-col>
					</dms-form>
				</el-main>
			</el-container>
		</el-container>
		<slot name="modal" />
	</el-container>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import { EventBus } from '@/main/eventBus';
import { navigateToReportRequests } from '@/main/utils/commonFunctions';

import { OperationFlags } from '#components/dms/common/operationFlagsConstants';
import Close from '#components/dms/button/Close.vue';

import { ScreenSize } from '../components/constants';

export default Vue.extend({
	name: 'DmsFilterLayout',
	components: {
		'dms-close': Close,
	},
	props: {
		model: { type: Object, default: () => { } },
		validationRules: { type: Object, default: () => { } },
		operations: { type: Number, default: 0 },
		closeClick: { type: Function, default: () => { } },
		canClose: { type: Boolean, default: true },
		useCreate: { type: Boolean, default: true },
		filterClick: { type: Function, default: () => { } },
		filterResetClick: { type: Function, default: () => { } },
		createClick: { type: Function, default: () => { } },
		exportClick: { type: Function, default: () => { } },
		beginWithDisplayedFilter: { type: Boolean, required: true },
		mainClass: { type: String, default: 'd-flex' },
		halfWidth: { type: Boolean, default: false },
		componentName: { type: String, default: null },
		screenSize: { type: Number, default: 0 },
		searchButtonLabelKey: { type: String, default: 'Search' },
		showReportRequestButton: { type: Boolean, default: false }, // Only this prop needed
	},
	data() {
		return {
			tableFilterQuery: '',
			showFilter: !this.beginWithDisplayedFilter,
			drawer: !this.beginWithDisplayedFilter,
			showArrowforList: false,
			tabletScreenSize: ScreenSize.TABLET,
		};
	},
	computed: {
		isFilterSlotEmpty() {
			return !this.$slots.filter;
		},
		canCreate() {
			// eslint-disable-next-line no-bitwise
			return this.operations & OperationFlags.CREATE;
		},
		canExport() {
			// eslint-disable-next-line no-bitwise
			return this.operations & OperationFlags.EXPORT;
		},
		quickSearchHint() {
			return this.LocalizeTitle('X_RYCHLE_HLEDANI');
		},
		quickSearchPlaceholder() {
			return this.Localize('X_RYCHLE_HLEDANI');
		},
		mainForm() {
			return this.$refs.mainForm;
		},
	},
	created() {
		this.debouncedFastSearch = _.debounce(this.fastSearch, 300);
		window.addEventListener('resize', this.getWidth);
	},
	mounted() {
		this.getSpanWidth();
	},
	destroyed() {
		window.removeEventListener('resize', this.getWidth);
	},
	methods: {
		fastSearch() {
			EventBus.$emit('tableFilterQuery', this.tableFilterQuery);
		},
		toggleFilter() {
			this.showFilter = !this.showFilter;
			this.drawer = !this.drawer;
		},
		onFilterSubmit() {
			this.filterClick();
		},
		navigateToReportRequests() {
			navigateToReportRequests();
		},
		scrollNavbarRight() {
			const content = document.querySelector('.button-box_for-list');
			if (content !== null) {
				content.scrollLeft += 50;
			}
		},
		scrollNavbarLeft() {
			const content = document.querySelector('.button-box_for-list');
			if (content !== null) {
				content.scrollLeft -= 50;
			}
		},
		getWidth() {
			this.showArrowforList = this.screenSize !== 0 ? window.innerWidth <= this.screenSize : window.innerWidth <= this.tabletScreenSize;
		},
		getSpanWidth() {
			this.$nextTick(() => {
				this.showArrowforList = this.screenSize !== 0 ? window.innerWidth <= this.screenSize : window.innerWidth <= this.tabletScreenSize;
			});
		},
	},
});
</script>

<style lang="scss" scoped>
::v-deep .info-button {
	margin: 0 0 0 3px;
}

.filter-display{
	display: inline-flex;
}
.filter-input-size {
	width: calc(100% - 70px);
}

.el-input.full-grid-filter-input-size {
	width: 25%
}

.half-width {
	width: 50%;
}

.filter-width {
	width: 25%;
}
 .button-box_for-list {
	max-width: 60%;
	overflow: auto;
	display: inline-flex;
}
.span-align
{
	float:right;
}
@media screen and (max-width: 768px) {
	.el-input.full-grid-filter-input-size {
		width: 40%
	}
}

@media (max-width: 992px) {
	.button-box_for-list {
	max-width: 43% !important;
	}
}
.button-box_for-list::-webkit-scrollbar {
    display: none;
  }

</style>
